<div *ngIf="!disabledHeader" class="gl-dashboard__header">
  <div class="gl-dashboard__title">
    <span>{{ 'dashboard.widgets.autoevaluationCourse' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.autoevaluationCourseTooltip' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
</div>
<div *ngIf="isEmpty" class="gl-dashboard__void">
  <span>{{ 'dashboard.widgets.notEvaluation' | translate }}</span>
</div>
<div *ngIf="!isEmpty">
  <div class="gl-dashboard__select" [ngClass]="{ readonly: readonly }">
    <lms-select-dropdown
      [readonly]="readonly"
      [items]="coursesOptions"
      [selectedItem]="selectedCourse?.courseId"
      (change)="setSelectedCourse($event)"
    ></lms-select-dropdown>
  </div>
  <div class="gl-dashboard__row courses" *ngIf="selectedCourse">
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.responseNumber' | translate }}</span>
      <span class="value">{{ selectedCourse.surveysCount | number : '1.0-1' }}</span>
    </div>
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.beforeMedia' | translate }}</span>
      <span class="value">{{ selectedCourse.avgPre | number : '1.0-1' }}</span>
    </div>
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.afterMedia' | translate }}</span>
      <span class="value">{{ selectedCourse.avgPost | number : '1.0-1' }}</span>
    </div>
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.improve' | translate }}</span>
      <span class="value" [ngClass]="selectedCourse.improvement >= 0 ? 'success' : 'failed'">
        {{ selectedCourse.improvement | number : '1.0-0' }}%
      </span>
    </div>
  </div>
  <div #autoevaluation_questions class="gl-dashboard__chart">
    <canvas
      #autoevaluation_radar_chart
      baseChart
      [type]="'radar'"
      [labels]="radarChartLabels"
      [datasets]="radarChartData"
      [options]="radarChartOptions"
      width="316"
      height="316"
    >
    </canvas>
    <div class="gl-dashboard__chart--labels">
      <span
        *ngFor="let question of radarChartQuestions"
        class="radar-chart-question animation_fade-in lmstooltip"
        [ngStyle]="question.style"
      >
        <span class="radar-chart-question__item">{{ question.text | translate }}</span>
        <span class="lms-tooltip top center">
          {{ question.text | translate }}
        </span>
      </span>
    </div>
  </div>
</div>
<div *ngIf="!isEmpty && clientId" class="gl-dashboard__links positionFixed">
  <a
    class="gl-dashboard__links--item"
    [queryParams]="{ reportType: 'selfassessment', clientId: clientId }"
    [routerLink]="['/reports/surveys']"
  >
    <span>{{ 'nouns.viewReports' | translate }}</span>
    <span class="glicon-arrow-right"></span>
  </a>
</div>
